<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Referral note",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Referral Note",
    };
  },
  computed: {
    ...mapGetters("inpatient", ["Referralform"]),
  },
  methods: {
    ...mapActions({
      PrintReferForm: "inpatient/print_referForm",
    }),
  },
  created() {
    this.PrintReferForm(this.$route.params.id);
  },
};
</script>
<style scoped>
.print {
  font-family: "Lucida Console", "Courier New", monospace;
}
.para_class {
  margin: 5px;
  font-size: 14px;
}
.padnote {
  margin-bottom: 250px;
}
.headings {
  font-size: 17px;
  font-weight: bold;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
        <div class="bg-white p-2 print">
          <div class="invoice-title">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <b-spinner
                  v-if="!Referralform.clinic"
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <img
                  v-else
                  :src="Referralform.clinic ? Referralform.clinic.clinicLogo : '---'"
                  alt="logo"
                  height="115px"
                />
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <p
                  style="
                    text-transform: uppercase;
                    text-align: right;
                    font-size: 20px;
                    font-weight: bold;
                  "
                >
                  {{ Referralform.clinic ? Referralform.clinic.clinicName : "-----" }}
                </p>
                <table align="right" width="100%" style="font-size: 12px">
                  <tr align="right">
                    <td
                      v-html="
                        Referralform.clinic ? Referralform.clinic.clinicAddress : '---'
                      "
                    ></td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      {{
                        Referralform.clinic ? Referralform.clinic.clinicContact : "---"
                      }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Email:</strong>
                      {{ Referralform.clinic ? Referralform.clinic.clinicMail : "---" }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-12">
              <table width="100%">
                <h4 style="float: center">REFERRAL NOTE</h4>
                <tr>
                  <td width="50%">
                    <p class="para_class">
                      Date of Referral:<b>{{
                        Referralform.referral_date ? Referralform.referral_date : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      To:<b>{{
                        Referralform.referred_to ? Referralform.referred_to : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      From(Health unit):
                      <b>
                        {{
                          Referralform.clinic ? Referralform.clinic.clinicName : "---"
                        }}</b
                      >
                    </p>

                    <p class="para_class">
                      Referral Number:
                      <strong
                        >{{
                          Referralform.referral_number
                            ? Referralform.referral_number
                            : "---"
                        }}
                      </strong>
                    </p>
                  </td>
                  <td style="text-align: left">
                    <p class="para_class">
                      Patient Name:
                      <b>{{
                        Referralform.patient
                          ? Referralform.patient.patient_address
                          : "_______"
                      }}</b>
                    </p>
                    <p class="para_class">
                      Patient Conatct:<b>{{
                        Referralform.patient.patient_contact
                          ? Referralform.patient.patient_contact
                          : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      Age:
                      <strong>
                        {{ Referralform.age ? Referralform.age : "_______" }}
                        <span v-if="Referralform.age_unit == 1">Years</span>
                        <span v-if="Referralform.age_unit == 2">Months</span>
                        <span v-if="Referralform.age_unit == 3">Days</span>
                      </strong>
                    </p>
                    <p class="para_class">
                      Sex:<b>{{
                        Referralform.patient_gender
                          ? Referralform.patient_gender
                          : "_______"
                      }}</b>
                    </p>
                  </td>
                </tr>
              </table>
              <hr />
              <table width="100%">
                <p>
                  Please attend to the above person who we are referring to your health
                  unit for further action
                </p>
                <tr class="padnote">
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">History and symptoms</span>: <br />
                      <span
                        v-html="
                          Referralform.historys
                            ? Referralform.historys
                            : '______'
                        "
                      ></span>
                    </p>
                  </td>
                </tr>

                <br />
                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Investigations Done</span>: <br />
                      <span
                        v-html="
                          Referralform.investigations_done
                            ? Referralform.investigations_done
                            : '______'
                        "
                      ></span>
                    </p>
                  </td>
                </tr>
                <br />

                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Diagnosis Done</span>:
                      <br />
                      {{
                        Referralform.final_diagnosis
                          ? Referralform.final_diagnosis
                          : "______"
                      }}
                    </p>
                  </td>
                </tr>
                <br />

                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Treatment Given</span>: <br />{{
                        Referralform.treatment ? Referralform.treatment : "______"
                      }}
                    </p>
                  </td>
                </tr>

                <br />
                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Reason for referral:</span> <br />
                      {{
                        Referralform.reasion_referral
                          ? Referralform.reasion_referral
                          : "_______"
                      }}
                    </p>
                  </td>
                </tr>

                <br />
                <p>
                  <b
                    >Please complete this note on discharge and send it back to our
                    unit</b
                  >
                </p>
              </table>
              <table width="100%">
                <tr>
                  <td>Clinician Name : __________</td>
                  <td>Contact : __________</td>
                  <td>Signature : _________</td>
                </tr>
              </table>
            </div>
          </div>
          <hr />
          <br />
          <table width="100%">
            <center>
              ========== <b>To be completed at the referral site</b> ==========
            </center>
            <tr class="padnote">
              <td width="100%">
                <p style="margin-botton: 10px">
                  <span class="headings">Futher Investigations Done</span>:
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </p>
              </td>
            </tr>

            <br />
            <tr>
              <td width="100%" height="80%">
                <p style="margin-botton: 12px">
                  <span class="headings">Diagnosis</span>:
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </p>
              </td>
            </tr>
            <br />

            <tr>
              <td width="100%">
                <p style="margin-botton: 10px">
                  <span class="headings">Treatement Given</span>:
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </p>
              </td>
            </tr>
            <br />

            <tr>
              <td width="100%">
                <p style="margin-botton: 10px">
                  <span class="headings">Treatment or survillance to be continued</span>:
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
